export enum IconsType {
  activity = 'activity',
  activityLog = 'activityLog',
  addDocument = 'addDocument',
  addUsers = 'addUsers',
  alertTriangle = 'alertTriangle',
  analysis = 'analysis',
  approveTick = 'approveTick',
  arrow = 'arrow',
  arrowRight = 'arrowRight',
  assets = 'assets',
  autoAwesome = 'autoAwesome',
  barGraph = 'barGraph',
  basicInfo = 'basicInfo',
  benchmarking = 'benchmarking',
  benchmarkManagement = 'benchmarkManagement',
  building = 'building',
  calendar = 'calendar',
  camera = 'camera',
  checkWithCircle = 'checkWithCircle',
  closeIntegralLogo = 'closeIntegralLogo',
  cognitiveBrain = 'cognitiveBrain',
  collapsibleSidebar = 'collapsibleSidebar',
  competitorAnalysis = 'competitorAnalysis',
  cross = 'cross',
  dashboard = 'dashboard',
  delete = 'delete',
  documentManagement = 'documentManagement',
  dotSeachTwo = 'dotSeachTwo',
  dollarInCircle = 'dollarInCircle',
  doubleLeft = 'doubleLeft',
  doubleRight = 'doubleRight',
  download = 'download',
  economicAnalysis = 'economicAnalysis',
  edit = 'edit',
  eye = 'eye',
  eyeInvisible = 'eyeInvisible',
  eyeVisible = 'eyeVisible',
  fictionalLogo = 'fictionalLogo',
  file = 'file',
  files = 'files',
  filter = 'filter',
  footnote = 'footnote',
  functionalAnalysis = 'functionalAnalysis',
  functions = 'functions',
  gear = 'gear',
  graph = 'graph',
  greenTick = 'greenTick',
  greenTick2 = 'greenTick2',
  handShake = 'handShake',
  helpOutline = 'helpOutline',
  helpSolid = 'helpSolid',
  intangible = 'intangible',
  integralOpenLogo = 'integralOpenLogo',
  interExchange = 'interExchange',
  landingPage = 'landingPage',
  leftParagraph = 'leftParagraph',
  legalEntityManagement = 'legalEntityManagement',
  lightBulb = 'lightBulb',
  listBullet = 'listBullet',
  loading = 'loading',
  loadingThree = 'loadingThree',
  locationPointer = 'locationPointer',
  manufacturing = 'manufacturing',
  minus = 'minus',
  moneyStack = 'moneyStack',
  networkTree = 'networkTree',
  onboardingIllustration = 'onboardingIllustration',
  organization = 'organization',
  paragraph = 'paragraph',
  percentage = 'percentage',
  pieChart = 'pieChart',
  plus = 'plus',
  productCategory = 'productCategory',
  reset = 'reset',
  risks = 'risks',
  rocket = 'rocket',
  save = 'save',
  search = 'search',
  services = 'services',
  settings = 'settings',
  shoppingCart = 'shoppingCart',
  sideBarEclipse = 'sideBarEclipse',
  sixDotDrag = 'sixDotDrag',
  Smile = 'Smile',
  sort = 'sort',
  sortDescending = 'sortDescending',
  sparkle = 'sparkle',
  stopCircle = 'stopCircle',
  successTick = 'successTick',
  templateManagement = 'templateManagement',
  templateSubType = 'templateSubType',
  threeUsers = 'threeUsers',
  thumbsUp = 'thumbsUp',
  tick = 'tick',
  transaction = 'transaction',
  transactionManagement = 'transactionManagement',
  upload = 'upload',
  userBusinessCeo = 'userBusinessCeo',
  users = 'users',
  verified = 'verified',
  blueArrow = 'blueArrow',
}
